export const DEFAULT_CONSUMER_PRIORITY = 1;
export const FOCUSED_CONSUMER_PRIORITY = 255;

export const getRemoteVideoConsumers = (consumers = {}) =>
  Object.values(consumers).filter(
    consumer => consumer.track && consumer.track.kind === 'video',
  );

export const resolveRemoteVideoSelection = (
  videoConsumers = [],
  selectedVideoId = null,
) => {
  if (
    selectedVideoId &&
    videoConsumers.some(consumer => consumer.id === selectedVideoId)
  ) {
    return selectedVideoId;
  }

  return videoConsumers.length > 0 ? videoConsumers[0].id : null;
};

export const getHighestConsumerLayers = consumer => ({
  spatialLayer: Math.max(0, (consumer?.spatialLayers || 1) - 1),
  temporalLayer: Math.max(0, (consumer?.temporalLayers || 1) - 1),
});

export const getRemoteVideoObjectFit = consumer =>
  consumer?.appData?.share ? 'contain' : 'cover';

export const isLayeredVideoConsumer = consumer =>
  consumer?.type === 'simulcast' ||
  consumer?.type === 'svc' ||
  (consumer?.spatialLayers || 1) > 1 ||
  (consumer?.temporalLayers || 1) > 1;

export const setRemoteVideoFocusQuality = async (
  roomClient,
  consumer,
  focused,
) => {
  if (!roomClient || !consumer) {
    return false;
  }

  if (
    typeof roomClient.hasConsumer === 'function' &&
    !roomClient.hasConsumer(consumer.id)
  ) {
    return false;
  }

  try {
    if (!focused) {
      return await roomClient.setConsumerPriority(
        consumer.id,
        DEFAULT_CONSUMER_PRIORITY,
      );
    }

    const operations = [
      roomClient.setConsumerPriority(consumer.id, FOCUSED_CONSUMER_PRIORITY),
    ];
    if (isLayeredVideoConsumer(consumer)) {
      const {spatialLayer, temporalLayer} = getHighestConsumerLayers(consumer);
      operations.push(
        roomClient.setConsumerPreferredLayers(
          consumer.id,
          spatialLayer,
          temporalLayer,
        ),
      );
    }

    const results = await Promise.all(operations);
    return results.every(result => result === true);
  } catch {
    return false;
  }
};
